<template>
    <div class="main visible">
        <div class="content">
            <div class="close" @click="closeApp()"></div>
            <Intro v-if="phase === 0" @setPhase="setPhase" />
            <Question v-if="phase === 1" :question="questionForPhaseOne" @handleAnswer="storeAnswer" @back="goBack" />
            <Question v-if="phase === 2" :question="questionForPhaseTwo" @handleAnswer="storeAnswer" @back="goBack" />
            <Question v-if="phase === 3" :question="questionForPhaseThree" @handleAnswer="storeAnswer" @back="goBack" />
            <Final
                v-if="phase === 4"
                :heading="finalHeading"
                :answers="answers"
                @back="goBack"
                @signUp="signUp"
                @moreFaqs="moreFaqs"
            />
        </div>
    </div>
</template>

<script>
import Intro from '@/components/Intro.vue'
import Question from '@/components/Question.vue'
import Final from '@/components/Final.vue'
import jsonQuestions from '@/assets/data/questions.json'
import jsonFinalHeadings from '@/assets/data/finalHeadings.json'
import { storage } from '@/composables/storage'

export default {
    name: 'Main',
    components: {
        Intro,
        Question,
        Final
    },
    data () {
        return {
            appIsVisible: false,
            phase: 0,
            questions: jsonQuestions,
            finalHeadings: jsonFinalHeadings,
            answers: [],
            finalHeading: null
        }
    },
    computed: {
        questionForPhaseOne () {
            return this.questions.find(o => o.phase === 1)
        },
        questionForPhaseTwo () {
            return this.questions.find(o => o.phase === 2)
        },
        questionForPhaseThree () {
            let questions = JSON.parse(JSON.stringify(this.questions.find(o => o.phase === 3)))
            if (this.answers[0] && this.answers[0].answer === 'child') {
                const answers = questions.answers.filter(o => o.id !== 2)
                questions.answers = answers
            }

            return questions
        },
        urlPostfix () {
            let age = this.answers[0].answer
            let type = this.answers[2].answer === 'competition' ? 'competition' : 'recr'
            return `${age}${type}/?utm_source=kh&utm_campaign=keuzehulp&utm_id=v1&utm_term=${age}+${type}&utm_content=${age}${type}`
        }
    },
    watch: {
        answers: {
            deep: true,
            handler (newValue) {
                this.$nextTick(() => {
                    if (newValue.length > 2) {
                        const finalHeading = this.finalHeadings.find(o => o.goal === newValue[2].answer && o.age === newValue[0].answer)
                        this.finalHeading = finalHeading ? finalHeading.heading : ''
                    }
                })
            }
        }
    },
    mounted () {
        this.appIsVisible = storage.get('appIsVisible')
        storage.set('appIsVisible', true)
        storage.on('appIsVisible', (val) => {
            this.appIsVisible = val
        })
    },
    methods: {
        setPhase (phase) {
            this.phase = phase
        },
        storeAnswer (questionCode, answerCode) {
            let data = {
                question: questionCode,
                answer: answerCode,
            }

            if (this.phase <= 1) {
                this.answers = []
            }

            if (questionCode === 'age' && answerCode === 'child') {
                this.answers.push(data)
                this.answers.push({ question: 'level', answer: 'beginner' })
                this.phase = 3
            } else {
                if (this.answers.length >= this.phase) {
                    this.answers.splice((this.phase - 1), (this.answers.length - this.phase + 1))
                }
                this.answers.push(data)

                this.phase = this.phase + 1
            }
        },
        goBack () {
            if (this.answers[0] && this.answers[0].answer === 'child') {
                this.phase = 1
                this.answers = []
            } else {
                this.phase--;
                this.answers.splice(this.phase, 1);
            }
        },
        closeApp () {
            storage.set('appIsVisible', false)
        },
        signUp () {
            console.log('sign up')
            window.location.href = `/lid-worden/${this.urlPostfix}`
        },
        moreFaqs () {
            window.location.href = `/faq/${this.urlPostfix}`
        }
    }
}
</script>

<style lang="scss" scoped>
    @use '../assets/scss/main.scss' as *;

    .main {
        display: none;

        &.visible {
            display: block;
        }
    }

    .close {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        width: 2rem;
        height: 2rem;
        opacity: 0.67;
        background: transparent center / contain no-repeat url('../../public/img/times.svg');
        cursor: pointer;
        @include transition-out();

        &:hover {
            opacity: 1;
            transform: scale(1.2, 1.2);
           @include transition-in();
        }

        @include bp-lg {
            top: 2rem;
            right: 2rem;
        }
    }

</style>
